<div *ngIf="formGroup" [formGroup]="formGroup">
  <div class="form-item" *ngIf="!unVisibleComp['firstName']">
    <mat-form-field appearance="fill">
      <mat-label>firstName</mat-label>
      <input matInput placeholder="" formControlName="firstName" />
    </mat-form-field>
  </div>

  <div class="form-item" *ngIf="!unVisibleComp['lastName']">
    <mat-form-field appearance="fill">
      <mat-label>lastName</mat-label>
      <input matInput placeholder="" formControlName="lastName" />
    </mat-form-field>
  </div>

  <div class="form-item" *ngIf="!unVisibleComp['email']">
    <mat-form-field appearance="fill">
      <mat-label>email</mat-label>
      <input matInput placeholder="" formControlName="email" />
    </mat-form-field>
  </div>

  <div class="form-item" *ngIf="!unVisibleComp['createdAt']">
    <mat-form-field appearance="fill">
      <mat-label>createdAt</mat-label>
      <input matInput placeholder="" [matDatepicker]="mycreatedAt" formControlName="createdAt" />
      <mat-datepicker-toggle matSuffix [for]="mycreatedAt"></mat-datepicker-toggle>
      <mat-datepicker #mycreatedAt></mat-datepicker>
    </mat-form-field>
  </div>

  <div class="form-item" *ngIf="!unVisibleComp['userClientGroup']">
    <app-userclientgroup-form-auto-complete [formArr]="formGroup['_userClientGroup']" placeholder="userClientGroup">
    </app-userclientgroup-form-auto-complete>
  </div>

  <div class="form-item" *ngIf="!unVisibleComp['copywriterSetting']">
    <app-copywriterstylerecord-form-auto-complete [formCtrl]="formGroup['_copywriterSetting']" placeholder="copywriterSetting">
    </app-copywriterstylerecord-form-auto-complete>
  </div>

  <div class="form-item" *ngIf="!unVisibleComp['categoryEditor']">
    <mat-checkbox formControlName="categoryEditor">Can edit categories</mat-checkbox><br />
  </div>

  <div class="form-item" *ngIf="!unVisibleComp['tagEditor']"><mat-checkbox formControlName="tagEditor">Can edit tags</mat-checkbox><br /></div>

  <div class="form-item" *ngIf="!unVisibleComp['documentUpload']">
    <mat-checkbox formControlName="documentUpload">Can upload documents</mat-checkbox><br />
  </div>

  <div class="form-item" *ngIf="!unVisibleComp['complexDoc']">
    <mat-checkbox formControlName="complexDoc">Can upload complex documents</mat-checkbox><br />
  </div>

  <div class="form-item" *ngIf="!unVisibleComp['noPersonalDocspace']">
    <mat-checkbox formControlName="noPersonalDocspace">Disable personal docspace</mat-checkbox><br />
  </div>

  <div class="form-item" *ngIf="!unVisibleComp['roles']">
    <app-userrole-form-auto-complete [formArr]="formGroup['_roles']" placeholder="roles"> </app-userrole-form-auto-complete>
  </div>
</div>
